<template>
  <div>
    <div v-if="!dataloaded || !userDataLoaded" class="blackbox-loader"></div>

    <v-container v-if="dataloaded && userDataLoaded"  grid-list-md class="ma-0 pa-2" fluid>
      <v-layout row wrap>
        <v-flex md3 xs12 v-if="companies.length > 1 && !this.demoMode">
          <v-select
            class="ma-1"
            :items="filteredCompanies"
            :color="companyPrimaryColor"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"    
            item-text="name"
            item-value="id"
            v-on:input="loadMembershipData()"
            v-model="activeComp"
            no-data-text="Geen bedrijven gevonden."
            label="Selecteer bedrijf"
            outlined
            hide-details
            dense>
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content  class="pt-0" >
                  <v-text-field
                    :color="companyPrimaryColor"
                    placeholder="Zoeken"
                    prepend-inner-icon="search"
                    clearable
                    v-model="searchCompanies"
                    hide-details
                    dense
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <div v-if="searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
              <v-divider v-if="searchCompanies.length > 0"></v-divider>
            </template>
          </v-select>
        </v-flex>
        <v-flex  md9 xs12>

        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md6 xs12>
          <v-select
            class="ma-1"
            :items="mauticLists"
            :color="companyPrimaryColor"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"    
            item-text="segementId"
            item-value="segmentId"
            v-on:input="selectMauticList()"
            v-model="selectedMauticList"
            label="Mautic Segement"
            outlined
            hide-details
            dense>
          </v-select>
        </v-flex>
        <v-flex  md6 xs12>
          <div class="header-edit-button">
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
                <v-btn v-on="on" fab darken color="primary" @click="newMauticList.dialog = true">
                  <v-icon darken>add</v-icon>
                </v-btn>
              </template>
              <span style="color: #fff;">Nieuwe Mautic lijst toevoegen</span>
            </v-tooltip>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <div v-if="dataloaded && userDataLoaded && !deleting && mauticLists.length > 0" class="mt-5">
      <div class="content-box" v-if="contacts.length > 0">
        <v-card>
          <!-- <v-card-title>
            <v-text-field
              style="max-width: 300px;"
              v-model="search"
              :color="companyPrimaryColor"
              placeholder="Zoeken"
              outlined
              hide-details     
              background-color="#fff"                                                
              prepend-inner-icon="search"
              autocomplete="disabled"
              clearable>
            </v-text-field>
            <v-spacer></v-spacer>
          </v-card-title> -->

          <v-data-table
            :headers="headers"
            :items="contacts"
            :search="search"
            :items-per-page="10"
            :page.sync="mauticOnePage"
            @page-count="pageCountMauticOne = $event"
            show-expand
            :key="contactsChanged"
            single-expand
            hide-default-footer

            :no-results-text="`Geen resultaten gevonden voor: ${search}`"
            >
            <template v-slot:item="{item, isExpanded, expand,index}">
              <tr>
                <td>
                  <v-tooltip v-if="item.handled" right>
                    <template v-slot:activator="{on}">
                      <v-btn  v-on="on" icon><v-icon :color="$vuetify.theme.themes[theme].text" dark>mdi-checkbox-marked</v-icon></v-btn>
                    </template>
                    <span style="color: #fff;">Afgevinkt op: {{  item.handledTimestamp.seconds | moment("DD-MM-YYYY HH:mm")  }}u</span>
                  </v-tooltip>

                  <v-tooltip v-else right>
                    <template v-slot:activator="{on}">
                      <v-btn  v-on="on" @click="checkAsHandled(item.firebaseId, item.fields.all.salonhubid, index)" icon><v-icon :color="$vuetify.theme.themes[theme].text" dark>mdi-checkbox-blank-outline</v-icon></v-btn>
                    </template>
                    <span style="color: #fff;">Markeer als afgevinkt</span>
                  </v-tooltip>
                </td>
                <td>{{ item.fields.all.firstname }} {{ item.fields.all.lastname }}</td>
                <td>{{ item.fields.all.city }}</td>
                <td>{{ item.fields.all.lastvisit | moment("D MMM YYYY")}}</td>
                <td>{{ item.fields.all.lasttreatment }}</td>
                <td><v-icon :color="companyPrimaryColor" v-if="item.comments">mdi-comment-text</v-icon></td>
                <td><v-btn small @click="contactPerson(item.fields.all.salonhubid, item.comments)">Meer informatie</v-btn></td>
                <!-- <td>
                  <v-tooltip v-if="!isExpanded" bottom>
                    <template v-slot:activator="{on}">
                      <v-btn  v-on="on" icon @click="expand(true)" ><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_more</v-icon></v-btn>
                    </template>
                    <span style="color: #fff;">Meer informatie tonen</span>
                  </v-tooltip>

                  <v-tooltip v-if="isExpanded" bottom>
                    <template v-slot:activator="{on}">
                      <v-btn  v-on="on" icon @click="expand(false)" v-if="isExpanded"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_less</v-icon></v-btn>
                    </template>
                    <span style="color: #fff;">Meer informatie verbergen</span>
                  </v-tooltip>
                </td> -->
              </tr>
            </template>
            <!-- <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" style="padding: 0;">
                <v-card flat>
                  <v-card-text>

                    <v-layout row wrap>
                      <v-flex xs12>
                        <b>Extra informatie:</b><br>
                        {{ item.street }} {{ item.number }}<br>
                        {{ item.zipcode }} {{ item.city }}<br><br>
                      </v-flex>
                      <v-flex xs4 v-if="item.clientIdUrl">
                        <b>Paspoort/ID:</b><br>
                        <v-img width="250px" :src="item.clientIdUrl"></v-img>
                      </v-flex>
                      <v-flex xs4 v-if="item.clientCardUrl">
                        <b>Bankpas:</b><br>
                        <v-img width="250px" :src="item.clientCardUrl"></v-img>
                      </v-flex>
                      <v-flex xs4>
                        <b>Handtekening:</b><br>
                        <v-img width="250px" :src="item.clientSignature"></v-img>
                      </v-flex>
                    </v-layout>
      
                  </v-card-text>
                </v-card>
              </td>
            </template> -->
          </v-data-table>
          <div class="text-xs-center py-2" v-if="contacts.length > 10">
            <v-pagination v-model="mauticOnePage" :color="companyPrimaryColor" :length="pageCountMauticOne"></v-pagination>
          </div>
        </v-card>

      </div>
      <div style="width: 350px; margin: 50px auto;" class="text-center" v-else>
        <p>Er zijn geen Mautic contact in deze lijst</p>
      </div>
    </div>

    <div style="width: 350px; margin: 50px auto;" class="text-center" v-if="dataloaded && userDataLoaded && !deleting && mauticLists.length == 0">
      <p>Er zijn geen Mautic lijsten toegevoegd</p>
      <div class="text-center">
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn v-on="on" fab darken color="primary" style="display: block; margin: 15px auto;" @click="newMauticList.dialog = true">
              <v-icon darken>add</v-icon>
            </v-btn>
          </template>
          <span style="color: #fff;">Voeg een nieuwe Mautic lijst toe. </span>
        </v-tooltip>
      </div>
    </div>

    <v-dialog v-model="newMauticList.dialog" max-width="800" scrollable persistent>
    <v-card>
      <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
        <h2 style="color:white">Nieuwe Mautic lijst toevoegen</h2>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeNewMauticList()">
          <v-icon dark color="white">close</v-icon>
        </v-btn>
      </v-card-title>

      <v-alert
        class="ma-0 pa-2"
        v-if="newMauticList.feedback"
        :value="true"
        type="warning"
        >
        {{ newMauticList.feedback }} 
      </v-alert>

      <v-divider></v-divider>

      <v-card-text>
        
        <v-form  ref="addDossierForm" lazy-validation>

           <v-text-field
              class="mt-4"
              outlined
              :color="companyPrimaryColor"
              background-color="background"
              hide-details
              label="Mautic Segment Id"
              v-model="newMauticList.id"
              required
            ></v-text-field>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-container grid-list-md fluid class="ma-0 pa-0">
          <v-layout row wrap class="ma-0 pa-0">
            <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
              <v-btn
                outlined
                depressed
                color="#8B93A6"
                @click="closeNewMauticList()"
                >
                Annuleren
              </v-btn>
            </v-flex>
            <v-flex xs12 md6 class="text-right">
              <v-btn
                dark
                rounded
                :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                :color="companySecondaryColor"
                @click="addNewMauticList()"
                >
                Toevoegen
                <v-icon right dark>chevron_right</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-actions>


    </v-card>
    </v-dialog>

    <v-dialog v-model="contactInformation.dialog" max-width="800" scrollable persistent>
    <v-card>
      <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
        <h2 style="color:white">Contactinformatie</h2>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeContactInformation()">
          <v-icon dark color="white">close</v-icon>
        </v-btn>
      </v-card-title>

      <v-alert
        class="ma-0 pa-2"
        v-if="contactInformation.feedback"
        :value="true"
        type="warning"
        >
        {{ contactInformation.feedback }} 
      </v-alert>

      <v-divider></v-divider>

      <v-card-text>
        
        <v-form  ref="addDossierForm" lazy-validation>
            <p class="pt-4"><strong>Naam: </strong>{{ contactInformation.name }}</p>
            <p><strong>Email: </strong>{{ contactInformation.email }}</p>
            <p><strong>Telefoonnummer: </strong>{{ contactInformation.phone }}</p>

           <v-textarea
              class="mt-4"
              outlined
              :color="companyPrimaryColor"
              background-color="background"
              hide-details
              label="Opmerkingen"
              v-model="contactInformation.comments"
              required
            ></v-textarea>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-container grid-list-md fluid class="ma-0 pa-0">
          <v-layout row wrap class="ma-0 pa-0">
            <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
              <v-btn
                outlined
                depressed
                color="#8B93A6"
                @click="closeContactInformation()"
                >
                Annuleren
              </v-btn>
            </v-flex>
            <v-flex xs12 md6 class="text-right">
              <v-btn
                dark
                rounded
                :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                :color="companySecondaryColor"
                @click="saveContactInformation()"
                >
                Opslaan
                <v-icon right dark>chevron_right</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-actions>


    </v-card>
    </v-dialog>



  </div>
</template>


<script>
import { bus } from "../main";
import db from "../firebase/init";
import _lodash from "lodash";
import axios from "axios";
import AddMembershipForm from "../components/modals/AddMembership.vue";
import platform from 'platform'; 
import moment from 'moment';


export default {
  name: "MauticLists",
  data: () => ({
    activeComp: null,
    activeCompData: null,
    userDataLoaded: false,
    selectedBranchesOriginal: [],
    selectedBranches: [],
    selectedBranchesData: [],
    search: "",
    searchCompanies: "",
    selected: [],
    deleting: false,
    mauticOnePage: 1,
    pageCountMauticOne: 0,
    newMauticList:{
      dialog: false,
      id: "",
      feedback: null
    },
    contactsChanged: 0,
    mauticLists: new Array(),
    selectedMauticList: null,
    contactsWidthComments: new Array(),
    contactInformation: {
      dialog: false,
      email: "",
      name: "",
      phone: "",
      comments: "",
    },
    
    deleteCounter: 0,
    dataloaded: false,
    newQueueDialog: false,
    editQueueDialog: false,
    selectedClientQueueItem: {
      name: "",
      phone: "",
      treatment: "",
      branch: "",
      employee: "",
      salonhubId: "",
      queueEndDate: "",
      queueEndDateMoment: "",
      treatmenTime: "",
    },
    pagination: {
      rowsPerPage: "200",
      sortBy: "dateAdded.seconds",
      descending: false
    },
    removeBookings: "",
    selected: [],
    contacts: [],
    companies: [],
    queuePages: -1,
    headers: [
      {
        text: "",
        align: "right",
        width: "50px",
        sortable: false
      },
      {
        text: "Naam",
        align: "left",
        value: "fields.all.lastname",
        width: "200px"
      },
      {
        text: "Woonplaats",
        align: "left",
        value: "item.fields.all.city"
      },
      {
        text: "Laatste bezoek",
        align: "left",
        value: "fields.all.lastvisit"
      },
      {
        text: "Laatste behandeling",
        align: "left",
        value: "fields.all.lasttreatment"
      },
      {
        text: "",
        value: "data-table-expand",
        align: "right",
        width: "50px",
        sortable: false
      },
      {
        text: "",
        value: "data-table-expand",
        align: "right",
        width: "50px",
        sortable: false
      },

    ],
  }),

  created() {
    this.loadUserComp();
  },

  methods: {
    loadUserComp() {
      this.dataloaded = false;
      this.userDataLoaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let dossierPackage = _.indexOf(doc.data().packages, 'dossier')
              if (dossierPackage >= 0) {
                let company = doc.data();
                company.id = doc.id;
                this.companies.push(company);
              }
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
        })
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeCompData = this.companies[selectedCompanyIndex];
              this.activeComp = this.companies[selectedCompanyIndex].id;
              console.log("selectedCompanyIndex: ", selectedCompanyIndex)
              this.loadMauticSegements();
              this.userDataLoaded = true;
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.activeCompData = this.companies[0];
              this.activeComp = this.companies[selectedCompanyIndex].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadMauticSegements();
              this.userDataLoaded = true;
            }
          }
          // No selected company is set 
          else {
            this.activeCompData = this.companies[0];
            this.activeComp = this.companies[selectedCompanyIndex].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadMauticSegements();
            this.userDataLoaded = true;
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeCompData = this.companies[0];
          this.activeComp = this.companies[0].id;
          this.loadMauticSegements();
          this.userDataLoaded = true;
        }
      })
    },

    closeNewMauticList(){
      this.newMauticList.dialog = false;
      this.newMauticList.id = "";
    },

    closeContactInformation(){
      this.contactInformation.dialog = false; 
      this.contactInformation.name = ""; 
      this.contactInformation.email = "";
      this.contactInformation.phone = "";
      this.contactInformation.comments = "";
      this.contactInformation.handled = false;
      this.contactInformation.handledTimestamp = null;
    },

    checkAsHandled(firebaseId, salonhubId, index){
      if(firebaseId){
        db.collection("mauticListsContacts").doc(firebaseId).set({
          handled: true,
          handledTimestamp: new Date()
        },{merge: true})
      }
      else{
        db.collection("mauticListsContacts").add({
          compId: this.activeComp,
          segementId: this.selectedMauticList,
          salonhubId: salonhubId,
          comments: "",
          handled: true,
          handledTimestamp: new Date()
        })
      }
      this.contacts[index].handled = true;
      this.contacts[index].handledTimestamp = {
        seconds: moment().unix()
      };
      this.contactsChanged++
    },

    saveContactInformation(){
      db.collection("mauticListsContacts").add({
        compId: this.activeComp,
        segementId: this.selectedMauticList,
        salonhubId: this.contactInformation.salonhubId,
        comments: this.contactInformation.comments,
        handled: this.contactInformation.handled ? true : false,
        handledTimestamp: this.contactInformation.handled ? new Date() : null,

      })
      .then(() => {
        this.updateData(this.selectedMauticList);
        this.closeContactInformation(); 
      })
      .catch(error => {
        this.newMauticList.contactInformation = "Update van contact is niet gelukt."
        console.error("Error bij opslaan contact in Mautic Lijst: ", error);
      });
    },

    addNewMauticList(){
      this.newMauticList.feedback = null;
      if(this.newMauticList.id){
        db.collection("mauticLists").add({
          compId: this.activeComp,
          segementId: this.newMauticList.id
        })
        .then(() => {
          this.updateData(this.newMauticList.id);
          this.closeNewMauticList(); 
        })
        .catch(error => {
          this.newMauticList.feedback = "Toevoegen van Mautic Lijst niet gelukt."
          console.error("Error bij toevoegen van Mautic Lijst: ", error);
        });
      }
      else{
        this.newMauticList.feedback = "Vul Mautic Segment Id in om door te gaan."
      }
    },

    selectMauticList(){
      this.getMauticContactCollection(this.selectedMauticList)
    },

    loadMauticSegements(id) {
      this.mauticLists = new Array();
      db.collection("mauticLists")
      .where("compId", "==", this.activeComp)
      .get()
      .then(snap => {
        snap.forEach(doc => {
          let mauticList = doc.data();
          mauticList.id = doc.id;
          this.mauticLists.push(mauticList);
        });
      })
      .then(() => {
        this.getMauticContactCollection(id)    
      })
      .catch(error => {
        this.dataloaded = true;
        console.error("Error bij laden mauticLists: ", error);
      });      
    },

    async getMauticContactCollection(id){
      this.dataloaded = false;
      this.contacts = new Array();
      this.contactsWidthComments = new Array();
      let segmentId = null;
      if(id){
        segmentId = id
      }
      else{
        if(this.mauticLists.length > 0){
          segmentId = this.mauticLists[0].segementId;
        }
      }
      if(segmentId){
        this.selectedMauticList = segmentId;

        var axios = require('axios');
        var data = JSON.stringify({
          "url": "beautybyroos.hogans.nl",
          "segmentId": segmentId
        });

        var config = {
          method: 'post',
          url: 'https://chatsend.hogans.nl/getContacts',
          headers: { 
            'Content-Type': 'application/json'
          },
          data : data
        };

        await axios(config)
        .then((response)=> {
          this.contacts = Object.values(response.data.contacts.contacts)
        })
        .catch(error=> {
          console.log(error);
        });

        await db.collection("mauticListsContacts")
        .where("compId", "==", this.activeComp)
        .where("segementId", "==", this.selectedMauticList)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let contact = doc.data();
            contact.id = doc.id;
            this.contactsWidthComments.push(contact);
          });
        })
        .catch(error => {
          this.dataloaded = true;
          console.error("Error bij laden mauticLists contacts with comments: ", error);
        });
        console.log("We gaan matchen")
        if(this.contactsWidthComments.length > 0 && this.contacts.length > 0){
          console.log("er valt wat te matchen")
          await new Promise((resolve)=>{
            let counter = 0;
            this.contacts.forEach(contact => {
              let internalCounter = 0;
              contact.firebaseId = null;
              contact.handeledTimestamp = null;
              contact.handeled = false;
              this.contactsWidthComments.forEach(commentContact => {
                  if(contact.fields.all.salonhubid == commentContact.salonhubId){
                    console.log("Match", commentContact.salonhubId)
                    contact.comments = commentContact.comments;
                    contact.handled = commentContact.handled ? true : false;
                    contact.handledTimestamp = commentContact.handledTimestamp ? commentContact.handledTimestamp : null;
                    contact.firebaseId = commentContact.id ? commentContact.id: null
                  }
                  internalCounter++
                  if(internalCounter == this.contactsWidthComments.length){
                    counter++
                    if(counter == this.contacts.length){
                      resolve()
                    }
                  }
              });
            });
          })
        }

        this.dataloaded = true;
      }
      else{
        this.dataloaded = true;
      }
    },

    contactPerson(salonhubid, comments){
      this.contactInformation.salonhubId = salonhubid
      axios
      .get(
        "https://public.salonhub.nl/current/" +
          this.activeCompData.salonhubApiSettings.customer +
          "/" +
          this.activeCompData.salonhubApiSettings.username +
          "/" +
          this.activeCompData.salonhubApiSettings.md5 +
          "/salon/" +
          this.activeCompData.salonhubApiSettings.salons[0].salonhubid +
          "/getCustomer?id=" +
          salonhubid
      )
      //axios.get(this.selectedTreatment.field_pintrest_rss, config)
      .then(response => {
        console.log("response: ", response.data)
        this.contactInformation.name = `${response.data.firstname} ${response.data.middlename} ${response.data.lastname}`
        this.contactInformation.email = response.data.email;
        this.contactInformation.phone = response.data.telephoneMobile ? response.data.telephoneMobile : response.data.telephoneHome ? response.data.telephoneHome : ""; 
        this.contactInformation.comments = comments ? comments : "";
        this.contactInformation.handled = handled ? handled : false;
        this.contactInformation.handledTimestamp = handledTimestamp ? handledTimestamp : null;
        
      })
      .catch(error => {
          console.error("Ophalen van salonhubklant niet gelukt: ", error);
        });
      this.contactInformation.dialog = true;  
    },

    showPreviewMembership(membership){
      this.previewMembership = membership;
      this.previewMembershipDialog = true
    },

    getMembershipType(type){
      let typeName = '';
      this.membershipTypes.forEach(element => {
        if(element.id == type){
          typeName = element.name
        }
      });
      return typeName;
    },   

    getBranchName(branche){
      let name = '';
      this.branches.forEach(element => {
        if(element.id == branche){
          name = element.branchName
        }
      });
      return name;
    },   


    updateData(id){
      this.dataloaded = false;
      this.loadMauticSegements(id)
    },


    addNewMembership(){
      bus.$emit("openMembershipDialog");
    },

    editClientQueueItem(item) {
      this.selectedClientQueueItem = Object.assign({}, item);
      this.selectedClientQueueItem.queueEndDatePicker  = moment.unix(item.queueEndDate.seconds).format("YYYY-MM-DD");
      this.selectedClientQueueItemOriginal = _.cloneDeep(this.selectedClientQueueItem);
      this.editQueueDialog = true;
    },

    goToDossier(salonhubId){
      this.$router.push('/dossier?id='+ salonhubId)
    },
  },

  computed: {
    demoMode(){
      return this.$store.state.demoMode;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userBranches() {
      return this.$store.state.userBranches;
    }, 
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    filteredCompanies(){
      return this.companies.filter(company => {
        return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
      });
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    branchesChanged() {
      if (
        _.isEqual(this.selectedBranches, this.selectedBranchesOriginal) == false
      ) {
        return false;
      } else {
        return true;
      }
    },
    branchesWidth(){
      if(this.companies.length > 1 && !this.demoMode){
        return "md6"
      }
      else{
        return "md9"
      }
    }
  }
};
</script>
<style>
.company-package{
  display: list-item;
  margin: 0;
}

.company-package-list{
  padding: 5px 0;
}
</style>
